module.exports = __webpack_public_path__ + "static/img/1.2edcc6f.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/8/sp/1.png
// module id = jCh0
// module chunks = 0